import ActionType from "../../action/ActionType";

const currentUser = (state = {}, {type, user}) => {
    if (type === ActionType.CURRENT_USER) {
        return user;
    }
    return state;
};

export default currentUser;